var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"source-with-count"},[_c('i',{staticClass:"d-flex justify-content-center align-items-center icon",class:_vm.icon}),_c('span',{staticClass:"text-grey-desc fs-12"},[_vm._v(_vm._s(_vm.formattedCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }